import React, { Fragment } from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import { StateContext } from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import { useTranslation } from "react-i18next";

const Alcohol = () => {
  const state = React.useContext(StateContext);
  const { isSidebarOpen } = state;
  const { t } = useTranslation();

  const whiskey = [
    { id: 1, title: "CHIVAS 18", price: "9.50" },
    { id: 2, title: "CHIVAS", price: "7.50" },
    { id: 3, title: "JACK DANIELS", price: "6.50" },
    { id: 4, title: "JACK DANIELS GENTELMAN", price: "7.50" },
    { id: 5, title: "JOHNNY WALKER", price: "5.00" },
  ];

  const vodka = [
    { id: 1, title: "VODKA GREY GOOSE", price: "7.50" },
    { id: 2, title: "VODKA BELVEDERE", price: "7.50" },
    { id: 3, title: "VODKA SMIRNOFF", price: "5.50" },
  ];

  const tequila = [{ id: 1, title: "TEQUILA", price: "4.00" }];
  const liqueurs = [
    { id: 1, title: "SOURZ APPLE", price: "3.50" },
    { id: 2, title: "SOURZ BERRY", price: "3.50" },
    { id: 3, title: "KRUŠKOVAC", price: "3.00" },
    { id: 4, title: "PELINKOVAC", price: "3.50" },
    { id: 5, title: "PELINKOVAC ANTIQUE", price: "5.00" },
    { id: 6, title: "JEGERMEISTER", price: "4.50" },
    { id: 7, title: "VIŠNJA", price: "4.00" },
    { id: 8, title: "MEDOVAČA", price: "4.50" },
    { id: 9, title: "APEROL", price: "6.50" },
  ];
  const gin = [
    { id: 1, title: "GIN MARE", price: "7.50" },
    { id: 2, title: "BOMBAY GIN", price: "5.50" },
  ];
  const brandy = [
    { id: 1, title: "ASBACH", price: "3.50" },
    { id: 2, title: "STOCK 84", price: "4.00" },
    { id: 3, title: "ŠLJIVA", price: "3.50" },
    { id: 4, title: "LOZA", price: "3.00" },
  ];

  return (
    <Fragment>
      {isSidebarOpen && (
        <>
          <div
            style={{
              backgroundImage: `url(${blackBackground})`,
              backgroundSize: "cover",
            }}
            className="content alcohol__box"
          >
            <div className="table__header">
              {" "}
              <h2>{t("alcohol:whiskey")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {whiskey.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("alcohol:vodka")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {vodka.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("alcohol:tequila")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {tequila.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("alcohol:liqueurs")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {liqueurs.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("alcohol:gin")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {gin.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("alcohol:brandy")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {brandy.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <CoverBoxes />
        </>
      )}
    </Fragment>
  );
};

export default Alcohol;
